import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowCircleIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M9 6.8a6.3 6.3 0 0 0-3.07 4.39 1 1 0 0 1-1.97-.33A8.2 8.2 0 0 1 8 5.07a8.2 8.2 0 0 1 8.43.08l2.56-2.57V9h-6.4l2.37-2.38A6.2 6.2 0 0 0 9 6.8M5.02 15h6.4l-2.39 2.38c1.8.92 4.04.93 5.97-.18a6.3 6.3 0 0 0 3.07-4.39 1 1 0 1 1 1.97.33A8.3 8.3 0 0 1 16 18.93a8.2 8.2 0 0 1-8.44-.08L5 21.43z" />
    </SvgIcon>
);
